import React from 'react';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';
import { useOperatorProficiency } from '@/contexts/OperatorProficiencyContext';

export const OperatorProficiencyCSVExport: React.FC = () => {
  const { data } = useOperatorProficiency();

  const handleExportCSV = () => {
    if (data && data.length > 0) {
      try {
        // Flatten the data for CSV export - matching table columns
        const flattenedData = data.map((row: any, index: number) => {
          // Extract top event types (handle both array and legacy object format)
          const abuses = row.topAbuses || row.topEvents;
          let topEventTypes = '';

          if (Array.isArray(abuses)) {
            topEventTypes = abuses
              .slice(0, 3)
              .map((a: any) => (typeof a === 'string' ? a : a.name))
              .filter(Boolean)
              .join(', ');
          } else if (abuses) {
            // Legacy object format
            const eventNames = [abuses.first?.name, abuses.second?.name, abuses.third?.name]
              .filter(Boolean);
            topEventTypes = eventNames.join(', ');
          }

          return {
            'Rank': row.rank ?? index + 1,
            'Driver ID': row.driverId || '',
            'Driver Name': row.driverName || row.name || row.operatorName || '',
            'Events Count': row.eventsCount ?? row.count ?? row.eventsDuration ?? 0,
            'Trend (%)': row.trend ?? row.eventsTrend ?? 0,
            'Top Event Types': topEventTypes,
          };
        });

        // Create CSV content
        const headers = Object.keys(flattenedData[0]);
        const csvRows = [
          headers.join(','),
          ...flattenedData.map(row =>
            headers.map(header => {
              const value = (row as any)[header];
              return typeof value === 'string' && value.includes(',')
                ? `"${value}"`
                : value;
            }).join(',')
          )
        ];
        const csvContent = csvRows.join('\n');

        // Create and trigger download
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.setAttribute('hidden', '');
        a.setAttribute('href', url);
        a.setAttribute('download', `operator_proficiency_${new Date().toISOString().split('T')[0]}.csv`);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error exporting CSV:', error);
      }
    }
  };

  return (
    <Button onClick={handleExportCSV} variant="outline" size="sm" disabled={!data || data.length === 0}>
      <Download className="h-4 w-4 mr-2" />
      Export to CSV
    </Button>
  );
};
